import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PlusCircle } from 'lucide-react';
import { createProject, updateProject, deleteProject, fetchProjects } from '../../actions/infrastructures';
import ProjectModal from '../../components/Modals/ProjectModal';
import ProjectCard from '../../components/Card/Project/ProjectCard';

const MyProjects = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isProjectModalOpen, setProjectModalOpen] = useState(false);
  const [projectToEdit, setProjectToEdit] = useState(null);
  const projects = useSelector(state => state?.infrastructures?.projects);

  useEffect(() => {
    dispatch(fetchProjects());
  }, [dispatch]);

  const handleProjectClick = (projectId) => {
    navigate(`/project/${projectId}`);
  };

  const handleDeleteProject = async(projectId) => {
    try {
      await dispatch(deleteProject(projectId));
    } catch (error) {
      console.error('Failed to delete project:', error);
    }
  };

  const handleEditProject = (projectId, project) => {
    setProjectModalOpen(true);
    setProjectToEdit(project);
  };  

  const handleProjectSubmit = async (projectData, userId) => {
    if (projectToEdit) {
      // If editing existing project
      dispatch(updateProject(projectToEdit.projectId, projectData));
    } else {
      // If creating new project
      await dispatch(createProject(projectData, userId));
    }
    // Reset selected project and close modal
    setProjectToEdit(null);
    setProjectModalOpen(false);
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">My Projects</h1>
        <button
          onClick={() => setProjectModalOpen(true)}
          className="inline-flex items-center px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors duration-200 font-medium shadow-sm"
        >
          <PlusCircle className="mr-2" /> Create Project
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projects?.map(project => (
          <ProjectCard
          key={project.projectId}
          project={project}
          onClick={() => handleProjectClick(project.projectId)}
          onDelete={() => handleDeleteProject(project.projectId)}
          onEdit={() => handleEditProject(project.projectId, project)}
        />
        ))}
      </div>

      <ProjectModal
        isOpen={isProjectModalOpen}
        onClose={() => {
          setProjectModalOpen(false);
          setProjectToEdit(null);
        }}
        onSubmit={handleProjectSubmit}
        initialData={projectToEdit}
      />
    </div>
  );
};

export default MyProjects;